module.exports = __webpack_public_path__ + "img/logo-list-3.32cd3675.png";